module.exports = "/assets/data/bce1b5eae8ef2ee6cd2479c1acace38e-B14.data.json";